import React from 'react';

const CenteredContent: React.FC = ({ children }) => {
  return (
    <span className="mx-0 my-auto" style={{ lineHeight: '24px' }}>
      {children}
    </span>
  );
};

export default CenteredContent;
